import React, { useMemo, useRef, useState, useEffect } from "react";
import { X, ChevronDown } from "lucide-react";

export default function MultiSelectChips({
  value = [],
  onChange,
  options = [],
  placeholder = "Search users...",
  name, // optional (Formik)
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const boxRef = useRef(null);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return term
      ? options.filter(o => o.label.toLowerCase().includes(term))
      : options;
  }, [q, options]);

  const toggleOpt = (opt) => {
    if (disabled) return;
    const exists = value.includes(opt.value);
    const next = exists ? value.filter(v => v !== opt.value) : [...value, opt.value];
    onChange?.(next);
  };

  const removeChip = (v) => onChange?.(value.filter(x => x !== v));

  useEffect(() => {
    const handler = (e) => {
      if (!boxRef.current || boxRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      {/* Input shell */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(s => !s)}
        className={`w-full min-h-[40px] rounded-md border border-gray-200 bg-white text-sm pl-3 pr-9 py-2 text-left
                    focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500
                    transition disabled:opacity-60 disabled:cursor-not-allowed`}
      >
        {value.length === 0 ? (
          <span className="text-gray-400">{placeholder}</span>
        ) : (
          <div className="flex flex-wrap gap-2">
            {value.map(v => {
              const opt = options.find(o => o.value === v);
              const label = opt?.label ?? v;
              return (
                <span key={v}
                  className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2 py-0.5 text-gray-700">
                  {label}
                  {!disabled && (
                    <X size={12} className="cursor-pointer"
                       onClick={(e) => { e.stopPropagation(); removeChip(v); }} />
                  )}
                </span>
              );
            })}
          </div>
        )}
        <ChevronDown size={16} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400" />
      </button>

      {/* Dropdown */}
      {open && !disabled && (
  <div
    className="absolute z-[9999] mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg"
    style={{ position: "absolute", top: "100%", left: 0 }}
  >
    {/* search + list */}
    <div className="p-2 border-b border-gray-100">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search…"
        className="w-full rounded-md border border-gray-200 bg-white px-2 py-1.5 text-sm focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
      />
    </div>
    <ul className="max-h-48 overflow-auto py-1">
      {filtered.length === 0 && (
        <li className="px-3 py-2 text-sm text-gray-400">No results</li>
      )}
      {/* {filtered.map(opt => {
        const active = value.includes(opt.value);
        return (
          <li
            key={opt.value}
            onClick={() => toggleOpt(opt)}
            className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-50 flex items-center justify-between ${
              active ? "bg-blue-50" : ""
            }`}
          >
            <span>{opt.label}</span>
            {active && <span className="text-blue-600 text-xs font-medium">Selected</span>}
          </li>
        );
      })} */}
      {filtered.map(opt => {
        const active = value.includes(opt.value);
        return (
          <li
            key={opt.value}
            onClick={() => toggleOpt(opt)}
            className={`px-3 py-2 text-sm cursor-pointer flex items-center justify-between
                        ${active
                          ? "bg-primary text-white hover:bg-primary"
                          : "hover:bg-gray-50"
                        }`}
          >
            <span>{opt.label}</span>
            {active && <span className="text-white text-xs font-medium">Selected</span>}
          </li>
        );
      })}
    </ul>
  </div>
)}

    </div>
  );
}
